import PlaylistIcon from '@atlaskit/icon-lab/core/playlist';
import * as React from 'react';

export function SvgPlaylist() {
  return <PlaylistIcon label="" testId="ads-refreshed-icon" />;
}
